import { LazyModule } from 'owa-bundling';
import type AugLoopPlugin from './plugin/AugLoopPlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import PluginNames from 'owa-editor-lazy-plugin/lib/utils/PluginNames';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AugLoopPlugin" */ './plugin/AugLoopPlugin')
);

export type LazyAugLoopPlugin = LazyPlugin<AugLoopPlugin>;

export let LazyAugLoopPluginClass = createLazyPlugin(
    lazyModule,
    m => m.default,
    PluginNames.AugLoop,
    null
);

export type {
    default as AnnotationHandler,
    GetAnnotationHandlerAsync,
} from './store/schema/AnnotationHandler';
export type { default as HandlerViewState } from './store/schema/HandlerViewState';
export type { ContentSubmitStrategy } from './store/schema/ContentSubmitStrategy';
export type { default as AugLoopEnvelope } from './store/schema/Envelope';
export { default as getRecipientsObject } from './utils/getRecipientsFromRecipientWells';
